var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"api-docs-frame",attrs:{"src":_vm.docsUrl,"title":"API Docs"}})}
var staticRenderFns = []

export { render, staticRenderFns }